module.exports = __webpack_public_path__ + "static/media/shift.fbca5832.png";